import { render, staticRenderFns } from "./fast_files.vue?vue&type=template&id=5c2646fd&scoped=true&"
import script from "./fast_files.vue?vue&type=script&lang=js&"
export * from "./fast_files.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2646fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c2646fd')) {
      api.createRecord('5c2646fd', component.options)
    } else {
      api.reload('5c2646fd', component.options)
    }
    module.hot.accept("./fast_files.vue?vue&type=template&id=5c2646fd&scoped=true&", function () {
      api.rerender('5c2646fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inbox/preview/fast_files.vue"
export default component.exports